import { useContext, useEffect, useState } from 'react';

import { Link, useParams } from 'react-router-dom';

import { EventContext } from '../../../Contexts/EventContext';
import Loading from '../../../Shared/Components/Loading';
import { error } from '../../../Shared/Components/Toast';
import useApi from '../../../Shared/hooks/api/Index';
import { useAccess } from '../../../Shared/hooks/useAccess';
import Master from '../../Layouts/Master';

const Register = () => {
  const [loading, setLoading] = useState(false);
  const eventContext = useContext(EventContext);
  const { id } = useParams();
  const { canManageMatches } = useAccess();

  useEffect(() => {
    getInfo();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getInfo = async () => {
    setLoading(true);
    await useApi.get(
      `/panel/match/${id}/register-match`,
      {},
      (res) => {
        const { data } = res.data;
        eventContext.allowProvinces = data?.allow_provinces;
        eventContext.matchPosts = data?.match_posts;
      },
      (err) => {
        error('خطا در دریافت اطلاعات');
        setLoading(false);
      },
    );
    setLoading(false);
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست موارد ثبت نام
          </h1>
        </div>
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.allowProvinces?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>نوع مسابقه</th>
                <th>استان</th>
                <th>نفرات/تیم</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.allowProvinces?.map((item, index) => (
                <tr key={item.id}>
                  <th>{index + 1}</th>
                  <td>{item?.match_kind?.name}</td>
                  <td>{item?.province?.name}</td>
                  <td>
                    {item?.match_kind?.id === 1 ? (
                      <div>تعداد نفرات : {item?.person_count}</div>
                    ) : (
                      <div className='d-flex flex-column'>
                        <span className='my-2'>
                          تعداد تیم : {item?.team_count}
                        </span>
                        <span className='my-2'>
                          نفرات تیم : {item?.person_count}
                        </span>
                      </div>
                    )}
                  </td>

                  <td>
                    <div className='d-flex flex-row'>
                      {canManageMatches() && (
                        <Link
                          to={`/panel/matches/register-match/match-allowed-province/${
                            item.id
                          }?team=${item?.team_count > 0 ? true : false}`}
                          className='mx-2'
                        >
                          فرم ثبت نام
                        </Link>
                      )}
                      {canManageMatches() && item?.match_kind?.id === 2 && (
                        <Link
                          to={`/panel/matches/register-match-posts/${
                            item?.id
                          }?team=${item?.team_count > 0 ? true : false}`}
                          className='mx-2'
                        >
                          ثبت سمت ها
                        </Link>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <i className='fad fa-plus f-16 mx-2 text-secondary'></i>
            <span className='f-13 font-weight-bold text-secondary'>
              برای ایجاد مسابقه بر روی منوی ایجاد مسابقه کلیک کنید
            </span>
          </div>
        )}
      </div>
    </Master>
  );
};

export default Register;
